var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0m1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0m1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M4.5 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3",
    clipRule: "evenodd"
  })));
};
export default SvgDotsHorizontal;